export const DEFAULT_COUNTRY_CODE = '974';

export function phoneDigits(raw) {
  return String(raw === null || raw === undefined ? '' : raw).replace(/\D/g, '');
}

export function formatPhone(stored, countryCode = DEFAULT_COUNTRY_CODE) {
  const digits = phoneDigits(stored);
  if (!digits) return '';

  const cc = phoneDigits(countryCode) || DEFAULT_COUNTRY_CODE;
  const local = digits.indexOf(cc) === 0 ? digits.slice(cc.length) : digits;
  if (!local) return `+${digits}`;

  const grouped = local.replace(/(\d{4})(?=\d)/g, '$1 ');
  return digits.indexOf(cc) === 0 ? `+${cc} ${grouped}` : `+${grouped}`;
}

export function normalisePhone(raw, countryCode = DEFAULT_COUNTRY_CODE) {
  let digits = phoneDigits(raw);
  if (!digits) return '';

  if (digits.indexOf('00') === 0) digits = digits.slice(2);

  const cc = phoneDigits(countryCode) || DEFAULT_COUNTRY_CODE;
  if (digits.length <= 9 && digits.indexOf(cc) !== 0) {
    digits = `${cc}${digits}`;
  }
  return digits;
}

export function formatPhoneCell(stored, countryCode = DEFAULT_COUNTRY_CODE) {
  const raw = String(stored === null || stored === undefined ? '' : stored).trim();
  if (!raw) return '';
  if (/[^\d\s]/.test(raw)) return raw;

  return formatPhone(normalisePhone(raw, countryCode), countryCode);
}

/**
 * The number to SHOW for a visitor row.
 *
 * Since dev_blocklist b6f4693 both GET /visitors/getvisitors and the type
 * "visitor" websocket frame decide by role: an Owner gets `phone_number`, a
 * building Admin gets `phone_number_masked` (66***567) and NO `phone_number`
 * at all. Reading `phone_number` alone left every Admin-side phone blank.
 */
export function visitorPhoneDisplay(row) {
  if (!row) return '';
  return String(
    row.phone_number || row.phone_number_masked || row.phoneNormalised || ''
  ).trim();
}

/**
 * The number to ACT on -- blocklist matching, the visit-history lookup, and
 * pre-filling the add-entry form.
 *
 * Deliberately does NOT fall back to the masked value: `66***567` cannot be
 * normalised, matched against a blocklist entry, or stored as one, and the
 * add-entry form rejects it anyway (it requires a full local number). An empty
 * string here means "this role cannot act on this row", and callers hide the
 * control rather than offering one that cannot work.
 */
export function visitorPhoneActionable(row) {
  if (!row) return '';
  return String(row.phone_number || row.phoneNormalised || '').trim();
}
